/**
 * Events Admin — Create, Edit, Copy Month Tool
 * Provides event creation form, pre-loaded migration events, and copy-month functionality.
 */
(function () {
  'use strict';

  var MONTHS = ['January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December'];

  var CATEGORIES = ['TCG', 'Magic', 'Yu-Gi-Oh', 'Pokemon', 'One Piece', 'Lorcana', 'Gundam', 'Shadowverse', 'Riftbound', 'X-Wing', 'Sports', 'Hockey', 'Video Games'];

  var MIGRATION_EVENTS = [
    { title: 'Wednesday Commander Night', date: '2026-06-03', time: '6:30 PM', cats: ['TCG', 'Magic'], price: 'free', ticket: '', recurring: 'weekly-wednesday', desc: 'Casual commander night. Come hang out and play some Magic!' },
    { title: 'Shadowverse Wednesday Locals', date: '2026-06-03', time: '6:00 PM', cats: ['TCG', 'Shadowverse'], price: 'free', ticket: '', recurring: 'weekly-wednesday', desc: 'Weekly Shadowverse Evolve tournament.' },
    { title: 'GundamTCG Wednesday Locals', date: '2026-06-03', time: '6:30 PM', cats: ['TCG', 'Gundam'], price: '10.00', ticket: 'pay-at-door', recurring: 'weekly-wednesday', desc: 'Entry: $10. Each participant receives a tournament participation pack. Store credit prizing for X-1 and better. First place receives a tournament winner pack.' },
    { title: 'Friday Night Yu-Gi-Oh', date: '2026-06-05', time: '6:30 PM', cats: ['TCG', 'Yu-Gi-Oh'], price: '5.00', ticket: 'pay-at-door', recurring: 'weekly-friday', desc: 'Tournament Entry: $5.00. Prizing depends on amount of players. Prizing for X-0 and X-1. Prize Pool: Store Credit.' },
    { title: 'Riftbound Nexus Nights 1v1', date: '2026-06-05', time: '6:30 PM', cats: ['TCG', 'Riftbound'], price: '10.00', ticket: 'pay-at-door', recurring: 'weekly-friday', desc: 'Entry: $10. Each participant receives a tournament promo. Store credit prizing for X-1 and better.' },
    { title: 'Saturday 1PM Modern', date: '2026-06-06', time: '1:00 PM', cats: ['TCG', 'Magic'], price: '5.00', ticket: 'pay-at-door', recurring: 'weekly-saturday', desc: 'Swiss rounds depending on the amount of players. Promo packs awarded to top cut finishers (until supplies last). 100% of the entries will be added to the prize pool split amongst X-0 & X-1 finishers.' },
    { title: 'Sunday MTG Legacy', date: '2026-06-07', time: '1:00 PM', cats: ['TCG', 'Magic'], price: '5.00', ticket: 'pay-at-door', recurring: 'weekly-sunday', desc: 'Tournament Entry: $5.00. Prizing depends on amount of players. Prizing for X-0 and X-1. Prize Pool: Store Credit.' },
    { title: 'Sunday One Piece Card Game', date: '2026-06-07', time: '1:00 PM', cats: ['TCG', 'One Piece'], price: '10.00', ticket: 'pay-at-door', recurring: 'weekly-sunday', desc: 'One Piece Card Game tournament. $10 entry.' },
    { title: 'Sunday Lorcana', date: '2026-06-07', time: '1:00 PM', cats: ['TCG', 'Lorcana'], price: 'free', ticket: '', recurring: 'weekly-sunday', desc: 'Casual Lorcana play every Sunday!' },
    { title: 'Monday One Piece Card Game', date: '2026-06-01', time: '7:00 PM', cats: ['TCG', 'One Piece'], price: 'free', ticket: '', recurring: 'weekly-monday', desc: 'Monday night One Piece Card Game tournament.' },
    { title: 'X-Wing Game Night', date: '2026-06-01', time: '6:00 PM', cats: ['TCG', 'X-Wing'], price: 'free', ticket: '', recurring: 'weekly-monday', desc: 'Casual Star Wars X-Wing game night.' }
  ];

  function EventsAdmin(container) {
    this.container = container;
    this.events = window.__EVENTS_DATA__ || [];
    this.storeDomain = container.getAttribute('data-store-domain') || '';
    this.activeTab = 'create';
    this.render();
  }

  EventsAdmin.prototype.buildTags = function (ev) {
    var tags = [];
    if (ev.date) tags.push('date:' + ev.date);
    if (ev.time) tags.push('time:' + ev.time);
    if (ev.cats) ev.cats.forEach(function (c) { if (c) tags.push('cat:' + c); });
    if (ev.price) tags.push('price:' + ev.price);
    if (ev.ticket) tags.push('ticket:' + ev.ticket);
    if (ev.recurring) tags.push('recurring:' + ev.recurring);
    return tags.join(', ');
  };

  EventsAdmin.prototype.render = function () {
    var html = '<div class="ea-container">';
    html += '<h2 class="ea-title">Events Admin</h2>';

    // Tabs
    html += '<div class="ea-tabs">';
    html += '<button class="ea-tab' + (this.activeTab === 'create' ? ' active' : '') + '" data-tab="create">Create Event</button>';
    html += '<button class="ea-tab' + (this.activeTab === 'migrate' ? ' active' : '') + '" data-tab="migrate">Import Events (' + MIGRATION_EVENTS.length + ')</button>';
    html += '<button class="ea-tab' + (this.activeTab === 'copy' ? ' active' : '') + '" data-tab="copy">Copy Month</button>';
    html += '<button class="ea-tab' + (this.activeTab === 'existing' ? ' active' : '') + '" data-tab="existing">Existing Events (' + this.events.length + ')</button>';
    html += '</div>';

    // Tab content
    if (this.activeTab === 'create') html += this.renderCreateForm();
    else if (this.activeTab === 'migrate') html += this.renderMigration();
    else if (this.activeTab === 'copy') html += this.renderCopyMonth();
    else if (this.activeTab === 'existing') html += this.renderExisting();

    html += '</div>';
    this.container.innerHTML = html;
    this.bindEvents();
  };

  EventsAdmin.prototype.renderCreateForm = function () {
    var html = '<div class="ea-panel">';
    html += '<h3>Create New Event</h3>';
    html += '<p class="ea-note">Fill in the form below. Click "Generate" to get the title and tags, then create the blog post in Shopify Admin.</p>';

    html += '<div class="ea-form">';
    html += '<div class="ea-row"><label>Event Title</label><input type="text" id="ea-title" placeholder="e.g., Friday Night Yu-Gi-Oh"></div>';
    html += '<div class="ea-row"><label>Date</label><input type="date" id="ea-date"></div>';
    html += '<div class="ea-row"><label>Start Time</label><input type="text" id="ea-time" placeholder="e.g., 6:30 PM"></div>';
    html += '<div class="ea-row"><label>Categories</label><div class="ea-checkboxes">';
    CATEGORIES.forEach(function (cat) {
      html += '<label class="ea-cb"><input type="checkbox" value="' + cat + '" class="ea-cat-cb"> ' + cat + '</label>';
    });
    html += '</div></div>';
    html += '<div class="ea-row"><label>Price</label><select id="ea-price-type"><option value="free">Free</option><option value="paid">Paid</option></select><input type="text" id="ea-price" placeholder="5.00" style="display:none;margin-left:8px;width:80px;"></div>';
    html += '<div class="ea-row"><label>Ticket Type</label><select id="ea-ticket"><option value="">None</option><option value="pay-at-door">Pay at Door</option><option value="custom">Online (product handle)</option></select><input type="text" id="ea-ticket-handle" placeholder="product-handle" style="display:none;margin-left:8px;width:150px;"></div>';
    html += '<div class="ea-row"><label>Recurring</label><select id="ea-recurring"><option value="">One-time event</option><option value="weekly-monday">Weekly Monday</option><option value="weekly-tuesday">Weekly Tuesday</option><option value="weekly-wednesday">Weekly Wednesday</option><option value="weekly-thursday">Weekly Thursday</option><option value="weekly-friday">Weekly Friday</option><option value="weekly-saturday">Weekly Saturday</option><option value="weekly-sunday">Weekly Sunday</option></select></div>';
    html += '<div class="ea-row"><label>Description</label><textarea id="ea-desc" rows="3" placeholder="Event description..."></textarea></div>';
    html += '<button class="ec-btn ec-btn-primary" id="ea-generate">Generate & Copy to Clipboard</button>';
    html += '</div>';

    html += '<div id="ea-output" style="display:none;margin-top:20px;">';
    html += '<h4>Copy this into Shopify Admin:</h4>';
    html += '<div class="ea-output-box"><strong>Title:</strong> <span id="ea-out-title"></span></div>';
    html += '<div class="ea-output-box"><strong>Tags:</strong> <span id="ea-out-tags"></span></div>';
    html += '<div class="ea-output-box"><strong>Content:</strong> <span id="ea-out-desc"></span></div>';
    html += '<a href="https://' + this.storeDomain + '/admin/articles/new" target="_blank" class="ec-btn ec-btn-primary" style="margin-top:10px;">Open Shopify Admin → Create Blog Post</a>';
    html += '</div>';

    html += '</div>';
    return html;
  };

  EventsAdmin.prototype.renderMigration = function () {
    var self = this;
    var html = '<div class="ea-panel">';
    html += '<h3>Import Events from BinderPOS</h3>';
    html += '<p class="ea-note">These are your recurring events extracted from the old calendar. Click each one to copy the title + tags, then paste into a new blog post in Shopify Admin.</p>';

    html += '<div class="ea-migration-list">';
    MIGRATION_EVENTS.forEach(function (ev, i) {
      var tags = self.buildTags(ev);
      html += '<div class="ea-migration-item">';
      html += '<div class="ea-migration-info">';
      html += '<div class="ea-migration-title">' + ev.title + '</div>';
      html += '<div class="ea-migration-meta">' + ev.date + ' | ' + ev.time + ' | ' + ev.cats.join(', ') + ' | ' + (ev.price === 'free' ? 'Free' : '$' + ev.price) + (ev.recurring ? ' | Recurring: ' + ev.recurring : '') + '</div>';
      html += '<div class="ea-migration-tags">Tags: <code>' + tags + '</code></div>';
      html += '</div>';
      html += '<div class="ea-migration-actions">';
      html += '<button class="ec-btn ec-btn-primary ea-copy-btn" data-title="' + ev.title + '" data-tags="' + tags.replace(/"/g, '&quot;') + '" data-desc="' + (ev.desc || '').replace(/"/g, '&quot;') + '">Copy & Create</button>';
      html += '</div>';
      html += '</div>';
    });
    html += '</div>';

    html += '<div style="margin-top:15px;">';
    html += '<button class="ec-btn ec-btn-primary" id="ea-copy-all-migration">Copy All to Clipboard</button>';
    html += '<a href="https://' + this.storeDomain + '/admin/articles/new" target="_blank" class="ec-btn ec-btn-secondary" style="margin-left:10px;">Open Shopify Admin</a>';
    html += '</div>';

    html += '</div>';
    return html;
  };

  EventsAdmin.prototype.renderCopyMonth = function () {
    var self = this;
    var now = new Date();
    var html = '<div class="ea-panel">';
    html += '<h3>Copy Month</h3>';
    html += '<p class="ea-note">Copy events from one month to another. Dates are auto-adjusted to match the same weekday position.</p>';

    html += '<div class="ea-controls">';
    html += '<div class="ea-control-group"><label>Source Month</label><select id="ea-src-month">';
    for (var i = -3; i <= 3; i++) {
      var d = new Date(now.getFullYear(), now.getMonth() + i, 1);
      var sel = i === 0 ? ' selected' : '';
      html += '<option value="' + d.getFullYear() + '-' + d.getMonth() + '"' + sel + '>' + MONTHS[d.getMonth()] + ' ' + d.getFullYear() + '</option>';
    }
    html += '</select></div>';
    html += '<div class="ea-control-group"><label>Target Month</label><select id="ea-tgt-month">';
    for (var j = 1; j <= 5; j++) {
      var t = new Date(now.getFullYear(), now.getMonth() + j, 1);
      html += '<option value="' + t.getFullYear() + '-' + t.getMonth() + '">' + MONTHS[t.getMonth()] + ' ' + t.getFullYear() + '</option>';
    }
    html += '</select></div>';
    html += '<button class="ec-btn ec-btn-primary" id="ea-load-copy">Load Events</button>';
    html += '</div>';

    // Show current month events
    var srcEvents = this.getEventsForMonth(now.getFullYear(), now.getMonth());
    if (srcEvents.length > 0) {
      html += '<table class="ea-table"><thead><tr><th>Event</th><th>Current Date</th><th>New Date</th><th>Tags</th></tr></thead><tbody>';
      srcEvents.forEach(function (ev) {
        var newDate = self.shiftDate(ev.date, now.getMonth(), now.getMonth() + 1, now.getFullYear());
        var tags = self.rebuildTags(ev, newDate);
        html += '<tr><td>' + ev.title + '</td><td>' + ev.date + '</td><td>' + newDate + '</td><td><code style="font-size:11px">' + tags + '</code></td></tr>';
      });
      html += '</tbody></table>';
      html += '<button class="ec-btn ec-btn-primary" id="ea-copy-month-all">Copy All for Next Month</button>';
    } else {
      html += '<p class="ea-empty">No events found for this month. Create some events first!</p>';
    }

    html += '</div>';
    return html;
  };

  EventsAdmin.prototype.renderExisting = function () {
    var html = '<div class="ea-panel">';
    html += '<h3>Existing Events</h3>';

    if (this.events.length === 0) {
      html += '<p class="ea-empty">No events found. Create some blog posts with event tags first.</p>';
    } else {
      html += '<table class="ea-table"><thead><tr><th>Title</th><th>Date</th><th>Time</th><th>Categories</th><th>Price</th><th>Recurring</th><th>Actions</th></tr></thead><tbody>';
      this.events.forEach(function (ev) {
        html += '<tr>';
        html += '<td>' + ev.title + '</td>';
        html += '<td>' + ev.date + '</td>';
        html += '<td>' + (ev.time || '-') + '</td>';
        html += '<td>' + (ev.categories || []).join(', ') + '</td>';
        html += '<td>' + (ev.price === 'free' ? 'Free' : ev.price ? '$' + ev.price : '-') + '</td>';
        html += '<td>' + (ev.recurring || 'One-time') + '</td>';
        html += '<td><a href="' + ev.url + '" target="_blank" class="ec-btn ec-btn-secondary" style="padding:4px 8px;font-size:11px;">Edit</a></td>';
        html += '</tr>';
      });
      html += '</tbody></table>';
    }

    html += '</div>';
    return html;
  };

  EventsAdmin.prototype.getEventsForMonth = function (year, month) {
    return this.events.filter(function (e) {
      if (!e.date) return false;
      var parts = e.date.split('-');
      return parseInt(parts[0]) === year && parseInt(parts[1]) - 1 === month;
    });
  };

  EventsAdmin.prototype.shiftDate = function (dateStr, srcMonth, tgtMonth, year) {
    var d = new Date(dateStr + 'T12:00:00');
    var dayOfWeek = d.getDay();
    var weekNum = Math.ceil(d.getDate() / 7);
    var tgtYear = tgtMonth > 11 ? year + 1 : year;
    var tgtM = tgtMonth > 11 ? tgtMonth - 12 : tgtMonth;

    var newD = new Date(tgtYear, tgtM, 1);
    var count = 0;
    while (newD.getMonth() === tgtM) {
      if (newD.getDay() === dayOfWeek) {
        count++;
        if (count === weekNum) break;
      }
      newD.setDate(newD.getDate() + 1);
    }
    if (newD.getMonth() !== tgtM) {
      newD = new Date(tgtYear, tgtM + 1, 0);
      while (newD.getDay() !== dayOfWeek) newD.setDate(newD.getDate() - 1);
    }
    return newD.getFullYear() + '-' + String(newD.getMonth() + 1).padStart(2, '0') + '-' + String(newD.getDate()).padStart(2, '0');
  };

  EventsAdmin.prototype.rebuildTags = function (ev, newDate) {
    var tags = ['date:' + newDate];
    if (ev.time) tags.push('time:' + ev.time);
    if (ev.categories) ev.categories.forEach(function (c) { if (c) tags.push('cat:' + c); });
    if (ev.price) tags.push('price:' + ev.price);
    if (ev.ticketHandle) tags.push('ticket:' + ev.ticketHandle);
    if (ev.recurring) tags.push('recurring:' + ev.recurring);
    return tags.join(', ');
  };

  EventsAdmin.prototype.bindEvents = function () {
    var self = this;

    // Tab switching
    this.container.querySelectorAll('[data-tab]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        self.activeTab = this.getAttribute('data-tab');
        self.render();
      });
    });

    // Price type toggle
    var priceType = document.getElementById('ea-price-type');
    var priceInput = document.getElementById('ea-price');
    if (priceType && priceInput) {
      priceType.addEventListener('change', function () {
        priceInput.style.display = this.value === 'paid' ? 'inline-block' : 'none';
      });
    }

    // Ticket type toggle
    var ticketSel = document.getElementById('ea-ticket');
    var ticketHandle = document.getElementById('ea-ticket-handle');
    if (ticketSel && ticketHandle) {
      ticketSel.addEventListener('change', function () {
        ticketHandle.style.display = this.value === 'custom' ? 'inline-block' : 'none';
      });
    }

    // Generate button
    var genBtn = document.getElementById('ea-generate');
    if (genBtn) {
      genBtn.addEventListener('click', function () {
        var title = document.getElementById('ea-title').value;
        var date = document.getElementById('ea-date').value;
        var time = document.getElementById('ea-time').value;
        var cats = [];
        document.querySelectorAll('.ea-cat-cb:checked').forEach(function (cb) { cats.push(cb.value); });
        var priceT = document.getElementById('ea-price-type').value;
        var price = priceT === 'free' ? 'free' : document.getElementById('ea-price').value;
        var ticketT = document.getElementById('ea-ticket').value;
        var ticket = ticketT === 'custom' ? document.getElementById('ea-ticket-handle').value : ticketT;
        var recurring = document.getElementById('ea-recurring').value;
        var desc = document.getElementById('ea-desc').value;

        var ev = { date: date, time: time, cats: cats, price: price, ticket: ticket, recurring: recurring };
        var tags = self.buildTags(ev);

        document.getElementById('ea-out-title').textContent = title;
        document.getElementById('ea-out-tags').textContent = tags;
        document.getElementById('ea-out-desc').textContent = desc;
        document.getElementById('ea-output').style.display = 'block';

        var clipText = 'Title: ' + title + '\nTags: ' + tags + '\nContent: ' + desc;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(clipText);
          alert('Copied to clipboard! Now paste into Shopify Admin.');
        }
      });
    }

    // Migration copy buttons
    this.container.querySelectorAll('.ea-copy-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var title = this.getAttribute('data-title');
        var tags = this.getAttribute('data-tags');
        var desc = this.getAttribute('data-desc');
        var text = 'Title: ' + title + '\nTags: ' + tags + '\nContent: ' + desc;
        if (navigator.clipboard) {
          navigator.clipboard.writeText(text);
          this.textContent = 'Copied!';
          this.style.backgroundColor = '#4CAF50';
          var b = this;
          setTimeout(function () { b.textContent = 'Copy & Create'; b.style.backgroundColor = ''; }, 2000);
        }
        window.open('https://' + self.storeDomain + '/admin/articles/new', '_blank');
      });
    });

    // Copy all migration
    var copyAll = document.getElementById('ea-copy-all-migration');
    if (copyAll) {
      copyAll.addEventListener('click', function () {
        var lines = MIGRATION_EVENTS.map(function (ev) {
          return 'Title: ' + ev.title + '\nTags: ' + self.buildTags(ev) + '\nContent: ' + (ev.desc || '') + '\n---';
        });
        if (navigator.clipboard) {
          navigator.clipboard.writeText(lines.join('\n\n'));
          alert('All ' + MIGRATION_EVENTS.length + ' events copied to clipboard!');
        }
      });
    }
  };

  document.addEventListener('DOMContentLoaded', function () {
    var container = document.getElementById('events-admin');
    if (container && container.style.display !== 'none') {
      new EventsAdmin(container);
    }
    // Re-check after URL param show
    setTimeout(function () {
      var c = document.getElementById('events-admin');
      if (c && c.style.display !== 'none' && !c.__init) {
        c.__init = true;
        new EventsAdmin(c);
      }
    }, 500);
  });
})();
